


















import { Component, Ref, Vue } from 'vue-property-decorator';
import SummaryTable from './components/summaryTable.vue';
import {summarySheetInstance} from './summarySheetUtils';
import SelectDepartment from '@/components/selectDepartment.vue';
import SelectProject from '@/components/selectProject.vue';
import moment, {Moment} from 'moment';

type IProjectInfo = IProject.IResponse.IProjectInfo;
let exportDates: string[] = [];

@Component({
  name: 'SummarySheet',
  components: {
    SummaryTable,
    SelectDepartment,
    SelectProject,
  },
})
export default class SummarySheet extends Vue {
  private dateInterval: Moment[] = [];
  private departmentId: string | undefined = undefined;
  private projectId: string | undefined = undefined;
  private spinning = false;
  @Ref() private readonly summaryTable!: SummaryTable;
  private sheetInstance = summarySheetInstance;
  get sheetData() {
    return this.sheetInstance.data;
  }
  get placeholder(): string[] {
    const result = [
      this.$t('report.settlementDate').toString(),
      this.$t('report.settlementDate').toString(),
    ];
    return result.map((str, index) => {
      const str2 = (index === 0) ? this.$t('operation.start').toString() : this.$t('operation.end').toString();
      return `${str} ${str2}`;
    });
  }
  private destroyed() {
    summarySheetInstance.clearData();
  }
  private handleSearch() {
    if (this.dateInterval.length < 2) {
      this.$message.warning(this.$t('report.selectInterval').toString());
      return;
    }
    exportDates = [];
    const dataDates: string[] = [];
    this.dateInterval.forEach((date, index) => {
      exportDates.push(moment(date).format('YYYY-MM-DD'));
      if (index === 0) {
        date.startOf('d');
      }
      if (index === 1) {
        date.endOf('d');
      }
      dataDates.push(moment.utc(date).format('YYYY-MM-DD HH:mm:ss'));
    });
    this.spinning = true;
    this.sheetInstance.requestData({
      StartDate: dataDates[0],
      EndDate: dataDates[1],
      DepartmentId: this.departmentId ? this.departmentId : undefined,
      ProjectId: this.projectId,
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.spinning = false;
    });
  }
  private handleExport() {
    this.summaryTable.exportExcel(exportDates);
  }
  private handleDepartmentChange(departmentId: string) {
    this.departmentId = departmentId || undefined;
  }
  private handleProjectChange(project?: IProjectInfo) {
    if (project) {
      this.projectId = project.id;
    } else {
      this.projectId = undefined;
    }
  }
}

